import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { ButtonPrimary } from './ButtonPrimary';

const borderStyle = (color) => css`
  border-top: 1px solid ${color};
  border-bottom: 1px solid ${color};

  &:before {
    border-left: 1px solid ${color};
  }

  &:after {
    border-right: 1px solid ${color};
  }
`;

export const ButtonPrimaryOutline = styled(ButtonPrimary)`
  background: #fff;
  ${({ theme }) => borderStyle(theme.colors.action)}

  &,
  &.MuiButton-root.Mui-disabled {
    color: ${({ theme }) => theme.colors.action};
  }

  &:hover {
    ${({ theme }) => borderStyle(theme.colors.actionStrong)}
    color: ${({ theme }) => theme.colors.actionStrong};
    background: #fff;
  }

  &:before,
  &:after {
    position: absolute;
    content: '';
    width: 8px;
    height: 100%;
    border-radius: 50%;
    background: inherit;
  }

  &:before {
    left: -4px;
  }

  &:after {
    right: -4px;
  }
`;
